document.addEventListener('DOMContentLoaded', function() {
  // Get all the scrolling wrappers on the page
  const scrollingWrappers = document.querySelectorAll('.horizontal-scroll-container');

  // Loop through each scrolling wrapper
  scrollingWrappers.forEach(scrollingWrapper => {
    // Find the buttons associated with the current wrapper
    const wrapper = scrollingWrapper.closest('.eck-entity'); // Find the closest ancestor with the class 'eck-entity'
    const previousButton = wrapper.querySelector('[data-horizontal-carousel-direction="left"]');
    const nextButton = wrapper.querySelector('[data-horizontal-carousel-direction="right"]');

    // Find the first card item within the current wrapper
    const item = scrollingWrapper.querySelector('.horizontal-scroll-card');

    // Calculate scroll amount based on the width of two card items
    const scrollAmount = item.getBoundingClientRect().width * 2;
    const animationDuration = 300; // Animation duration in milliseconds

    if (!scrollingWrapper || !previousButton || !nextButton) {
      return;
    }

    function updateButtonStates() {
      const maxScrollLeft = scrollingWrapper.scrollWidth - scrollingWrapper.clientWidth;
      previousButton.classList.toggle('disabled', scrollingWrapper.scrollLeft <= 0);
      nextButton.classList.toggle('disabled', scrollingWrapper.scrollLeft >= maxScrollLeft);
    }

    updateButtonStates();

    function animateScroll(targetScrollLeft) {
      const startScrollLeft = scrollingWrapper.scrollLeft;
      let startTime = null;

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      }

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const percentage = Math.min(progress / animationDuration, 1);
        const easedPercentage = easeInOutCubic(percentage);

        scrollingWrapper.scrollLeft = startScrollLeft + (targetScrollLeft - startScrollLeft) * easedPercentage;

        if (progress < animationDuration) {
          requestAnimationFrame(step);
        } else {
          updateButtonStates();
        }
      }

      requestAnimationFrame(step);
    }

    previousButton.addEventListener('click', function(event) {
      event.stopPropagation();
      const targetScrollLeft = scrollingWrapper.scrollLeft - scrollAmount;
      animateScroll(targetScrollLeft);
    });

    nextButton.addEventListener('click', function(event) {
      event.stopPropagation();
      const targetScrollLeft = scrollingWrapper.scrollLeft + scrollAmount;
      animateScroll(targetScrollLeft);
    });

    scrollingWrapper.addEventListener('scroll', updateButtonStates);
  });
});
